
import { defineComponent, PropType } from "vue";
import { ErrorMessage } from "vee-validate";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

export default defineComponent({
  name: "HtmlEditorInput",
  components: { QuillEditor, ErrorMessage },
  props: {
    input: { type: Object as PropType<any>, required: true },
    modelValue: { type: String, default: "" },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const editorOptions = {
      placeholder: props.input.placeholder || "Type here...",
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ["link"],
          ["clean"],
        ],
      },
    };

    const onChange = (html: string) => {
      emit("update:modelValue", html);
    };

    return { editorOptions, onChange };
  },
});
